import {
  AutosuggestProps,
  HomeVideoReviewSearchItem
} from "@bluframe/mightychroma-mightytool-frontend-types"

import EditActions from "./EditActions"

export interface Props {
  homeVideoReviewTitles: HomeVideoReviewSearchItem[]
  isUpdateHomeVideoReviewEnabled: boolean
  label: string
  loading: boolean
  onClearAll: () => void
  onGetSuggestions: AutosuggestProps["onGetSuggestions"]

  onSelectHomeVideoReviewId: (id: string, name: string) => void
  onUpdateHomeVideoReview: () => void
  selectedHomeVideoReviewId: string
}

export interface ComponentProps extends Props {}

export default EditActions
